(function () {
	// Mobile browsers emit resize events while the address bar appears and
	// disappears during a vertical scroll. Recreating Swiper for those events
	// recalculates the active slide's height, which makes product photos jump or
	// appear to zoom. Only rebuild when the layout width actually changes (for
	// example, an orientation change or a desktop window resize).
	let viewportWidth = document.documentElement.clientWidth;
	let resizeTimer;

	function swiperInit() {
		subSliderInit(true);
		sliderInit(true);
	}

	document.addEventListener('shopify:section:load', function (e) {
		swiperInit();
	});

	window.addEventListener('resize', function () {
		const nextViewportWidth = document.documentElement.clientWidth;
		if (nextViewportWidth === viewportWidth) return;

		viewportWidth = nextViewportWidth;
		window.clearTimeout(resizeTimer);
		resizeTimer = window.setTimeout(function () {
			$('.product-section .js-media-list').each(function () {
				if (this.swiper && !this.swiper.destroyed) this.swiper.destroy();
			});
			$('.product-section .js-media-sublist').each(function () {
				if (this.swiper && !this.swiper.destroyed) this.swiper.destroy();
			});

			swiperInit();
		}, 150);
	});

	swiperInit();
})();
